import getters from './../Getters/system.js';
import actions from './../Actions/system.js';
import mutations from './../Mutations/system.js';

export default {
    namespaced: true,

    state: {
        globalcfg: undefined,
        roles: undefined,
        invite: undefined,
        inviteInfo: undefined,
        inputLimits: undefined,
        signedInUsersCount: 0,
        isLoading: false,
        isDownloading: false,
        redirectInfo: undefined,
        reloadUI: undefined
    },

    getters,
    actions,
    mutations
};
